module.exports = __webpack_public_path__ + "media/images/front/bg_case_header_01-4d337aefe8bc75f6eb738fdb41962b87.jpg";